module.exports = __webpack_public_path__ + "img/29t.prt.a8dab4bb.jpg";